import "core-js/modules/es.array.push.js";
import { useCssVars as _useCssVars } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/course_empty1.png';
import _imports_1 from '@/assets/img/living.gif';
const _withScopeId = n => (_pushScopeId("data-v-ead6c896"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "live-card"
};
const _hoisted_2 = {
  class: "contain"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "image-slot"
}, [/*#__PURE__*/_createElementVNode("img", {
  style: {
    "height": "169px"
  },
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_5 = {
  key: 0,
  class: "live-tag"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "living"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "living-img",
  src: _imports_1,
  alt: "直播中"
}), /*#__PURE__*/_createTextVNode("直播中 ")], -1));
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  key: 1,
  class: "live-tag coming"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "living"
}, " 即将开课 ", -1));
const _hoisted_10 = [_hoisted_9];
const _hoisted_11 = {
  class: "course-card"
};
const _hoisted_12 = ["title"];
const _hoisted_13 = {
  key: 0,
  class: "course-price free"
};
const _hoisted_14 = {
  key: 1,
  class: "course-price"
};
const _hoisted_15 = {
  class: "card-bottom"
};
const _hoisted_16 = {
  class: "course-address"
};
const _hoisted_17 = {
  key: 0,
  class: "start-data"
};
const _hoisted_18 = {
  key: 0,
  class: "course-date"
};
const _hoisted_19 = {
  class: "start-data"
};
const _hoisted_20 = {
  key: 0
};
import { reactive, ref } from 'vue';
import { getImgUrl } from '@/utils/common';
import dayjs from 'dayjs';
import router from '@/router';
export default {
  __name: 'index',
  props: {
    courseData: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    const props = __props;
    _useCssVars(_ctx => ({
      "41879536": transform.value
    }));
    const clickCourse = val => {
      router.push({
        path: '/course/detail',
        query: {
          id: val,
          tab: 'introduction'
        }
      });
    };
    const state = reactive({
      flag: true
    });
    const transform = ref('translateX(0px)');
    const hanleToggleRight = () => {
      transform.value = 'translateX(-1216px)';
      state.flag = false;
    };
    const hanleToggleLeft = () => {
      transform.value = 'translateX(-0px)';
      state.flag = true;
    };
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.courseData, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "course-block",
          key: item,
          onClick: $event => clickCourse(item.id)
        }, [_createVNode(_component_el_image, {
          fill: "",
          class: "course-img",
          src: item.cover ? _unref(getImgUrl)(item.cover) : '',
          loading: "lazy"
        }, {
          error: _withCtx(() => [_hoisted_4]),
          _: 2
        }, 1032, ["src"]), item.broadcastStatus === 'LIVING' ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)) : _createCommentVNode("", true), item.broadcastStatus === 'UNSTART' ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
          class: "course-title",
          title: item.courseName
        }, _toDisplayString(item.courseName), 9, _hoisted_12), item.free === '0' ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 免费 ")) : (_openBlock(), _createElementBlock("div", _hoisted_14, " ￥ " + _toDisplayString(item.price), 1)), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [item.address ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(item.address), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", null, [item.courseStartTime && item.coursePlayType === '1' ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_Icon, {
          name: "el-icon-Clock"
        }), _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(dayjs)(+item.courseStartTime).format('YYYY-MM-DD')) + " 开课", 1)])) : _createCommentVNode("", true)])])])], 8, _hoisted_3);
      }), 128))])]), props.courseData.length > 4 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", {
        class: "arrow-left",
        onClick: hanleToggleLeft
      }, [props.courseData.length > 4 && !state.flag ? (_openBlock(), _createBlock(_component_Icon, {
        key: 0,
        name: "el-icon-ArrowLeftBold"
      })) : _createCommentVNode("", true)]), props.courseData.length > 4 && state.flag ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "arrow-right",
        onClick: hanleToggleRight
      }, [_createVNode(_component_Icon, {
        name: "el-icon-ArrowRightBold"
      })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
    };
  }
};